import React from "react";

const PrivacyPolicy = () => {
  // Define privacy policy sections
  const privacySections = [
    {
      title: "Introduction",
      content: `Welcome to Telephone Directory, a mobile application committed to prioritizing user privacy. This Privacy Policy outlines how we handle your personal information when you use our services.`,
    },
    {
      title: "Information We Collect",
      content: `When using Telephone Directory, we may collect specific personal information, primarily the account holder's mobile number. We collect this information solely for the purpose of providing you with a better service, enhancing your user experience, and responding effectively to your inquiries and support requests. Users maintain full control over their data and privacy and can request data deletion at any time by contacting us at <a href="mailto:info@code-b.dev" style="color: blue; text-decoration: underline;">info@code-b.dev</a>`,
    },
    {
      title: "Data Security",
      content: `We prioritize the security of your personal information and implement appropriate measures to protect it from unauthorized access, disclosure, alteration, and destruction.`,
    },
    {
      title: "Consent",
      content: `By using Telephone Directory, you consent to the terms outlined in this Privacy Policy.`,
    },
    {
      title: "Changes to This Privacy Policy",
      content: `We may update our Privacy Policy from time to time. Any changes will be effective immediately upon posting the revised policy.`,
    },
    {
      title: "Contact Us",
      content: `If you have any questions, concerns, or wish to request data deletion, please contact us at <a href="mailto:info@code-b.dev" style="color: blue; text-decoration: underline;">info@code-b.dev</a>.`,
    },
  ];

  return (
    <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "20px" }}>
      <div className="flex justify-center">
        <div className="mt-8 w-4/5 px-4">
          <h1 className="my-4 text-center text-3xl font-bold">
            Privacy Policy
          </h1>
          <ul className="list-disc">
            {privacySections.map((section, index) => (
              <li key={index} className="py-4">
                <h3 className="mb-2 text-lg font-bold">{section.title}</h3>
                <p
                  className="text-base leading-6"
                  dangerouslySetInnerHTML={{ __html: section.content }}
                ></p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
